(function() { window.GUID_88048322_9e35_488b_bc6c_f87c13f5a66c = { getGuid: function() { return "88048322-9e35-488b-bc6c-f87c13f5a66c"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Helper;
    (function (Helper) {
        class RenderAjaxAction {
            constructor(uniqueId, url, data) {
                this.Url = url;
                this.Data = data;
                this.TryGet(uniqueId, url, data);
            }
            TryGet(uniqueId, url, data) {
                let me = this;
                if (typeof (CompuSport.trigger) != "undefined") {
                    if (CompuSport.AllScriptsLoaded) {
                        me.CallGet(uniqueId, url, data);
                    }
                    else {
                        CompuSport.on('allscriptsloaded', function () {
                            me.CallGet(uniqueId, url, data);
                        });
                    }
                }
                else {
                    me.retry = window.setTimeout(function () {
                        me.TryGet(uniqueId, url, data);
                    }, 100);
                }
            }
            CallGet(uniqueId, url, data) {
                let me = this;
                CompuSport.Ajax.Get(url, data, function (result) {
                    let content = $('#' + uniqueId);
                    me.Container = $('<div class="RenderAjaxActionContainer">' + result + '</div>');
                    content.replaceWith(me.Container);
                    CompuSport.trigger('ajaxActionRendered', me);
                });
            }
            Refresh() {
                let me = this;
                CompuSport.Ajax.Get(this.Url, this.Data, function (result) {
                    me.Container.html(result);
                    CompuSport.trigger('ajaxActionRefreshed', me);
                });
            }
        }
        Helper.RenderAjaxAction = RenderAjaxAction;
    })(Helper = CompuSport.Helper || (CompuSport.Helper = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=RenderAjaxAction.js.map
